export const MILK_PREFERENCE_MAP: Record<string, string> = {
  "Whole Milk": "whole",
  "Semi-Skimmed Milk": "semiSkimmed",
  "Skimmed Milk": "skimmed",
  "Oat Milk": "oat",
  "Soya Milk": "soya",
  "Almond Milk": "almond",
  "Coconut Milk": "coconut",
};

export const MILK_PREFERENCE_REVERSE_MAP: Record<string, string> =
  Object.entries(MILK_PREFERENCE_MAP).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {} as Record<string, string>,
  );
